import { ChannelError } from '../../utils/channelError';

const chatChannelError = {
  [ChannelError.CHANNEL_NOT_FOUND]: `Chat channel not found for the current user.
We have reported this issue to our team!`,
  [ChannelError.FEATURE_DISABLED]: 'Chat feature is disabled for the current user!',
};

export {
  chatChannelError,
};
